module.exports = __webpack_public_path__ + "img/icon_box_green.5a4010ca.png";